import Vue from 'vue'
const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	schoolTeachers : [],
	schoolStudents:[],
    schoolUser:    {
        name:null,
        email:null,
        mobile:null,
        type:null,
        password:null
    },
	schoolDetails:{

	},
	schools : [],
	current_school : null
}

const getters = {
	fetchSchoolTeachers : (state) => state.schoolTeachers,
	fetchSchoolStudents : (state) => state.schoolStudents,
	fetchSchoolDetails : (state) => state.schoolDetails,
	fetchSchools : (state) => state.schools,
	fetchCurrentSchool : (state) => state.current_school
}

const actions = {
	loadSchools({commit}, {token} = {}){
		return $http.get('school', {
			headers : token ? { 'x-auth-token' : token } : {}
		}).then((response) => {
			commit('SET_SCHOOLS', response.data.data || [])
			return response.data
		})
	},

	loadSchoolById({commit}, {id, token} = {}){
		return $http.get(`school/${id}`, {
			headers : token ? { 'x-auth-token' : token } : {}
		}).then((response) => {
			commit('SET_CURRENT_SCHOOL', response.data.data)
			return response.data
		})
	},

	createSchool({commit}, {school, token}){
		return $http.post('school', school, {
			headers : { 'x-auth-token' : token }
		}).then((response) => {
			if(response.data.success){
				commit('ADD_SCHOOL', response.data.data)
			}
			return response.data
		})
	},

	updateSchool({commit}, {id, school, token}){
		return $http.put(`school/${id}`, school, {
			headers : { 'x-auth-token' : token }
		}).then((response) => {
			if(response.data.success){
				commit('UPDATE_SCHOOL', response.data.data)
			}
			return response.data
		})
	},

	deleteSchool({commit}, {id, token}){
		return $http.delete(`school/${id}`, {
			headers : { 'x-auth-token' : token }
		}).then((response) => {
			if(response.data.success){
				commit('REMOVE_SCHOOL', id)
			}
			return response.data
		})
	},

	createSchoolAdminForSchool(_ctx, {id, schoolUser, token}){
		const payload = {}
		for(let key in schoolUser){
			if(schoolUser[key] != null && schoolUser[key] !== ''){
				payload[key] = schoolUser[key]
			}
		}
		return $http.post(`school/${id}/admin`, payload, {
			headers : { 'x-auth-token' : token }
		}).then((response) => response.data)
	},

	loadSchoolUsers({commit}, {token, type}){
		return $http.get(`user?type=${type}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			if(type=="P")	
				commit('SET_SCHOOL_STUDENTS', response.data.data)
			else
				commit('SET_SCHOOL_TEACHERS', response.data.data)
			
		})
	},
	loadSchoolDetails({commit}, {token, id}){
		return $http.get(`school/${id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
				console.log(reponse.data.data)
				commit('SET_SCHOOL_DETAILS', response.data.data)
		})
	},
	createSchoolUser({commit}, {schoolUser, token}){
		
		for(let key in schoolUser){
			if(schoolUser[key] == null){
				delete schoolUser[key]
			}
		}
		
		return $http.post('user/school', schoolUser, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			if(response.data.data.type=="P")
				commit('ADD_SCHOOL_STUDENT', response.data.data)
			else if(response.data.data.type=="ST")
				commit('ADD_SCHOOL_TEACHER', response.data.data)
			
			return response.data
		})
	},
	
    // updateTeacher({commit}, {id, teacher, token}){
	// 	// let category_formdata = new FormData()
	// 	// for(let key in category){
	// 	// 	if(key == 'categoryfiles'){
	// 	// 		for(let i in category[key]){
	// 	// 			category_formdata.append(`${key}`, category[key][i])
	// 	// 		}
	// 	// 	}else if(key == 'editfiles'){
	// 	// 		category_formdata.append(key, JSON.stringify(category[key]))
	// 	// 	}else{
	// 	// 		category_formdata.append(key, category[key])
	// 	// 	}	
	// 	// }

	// 	for(let key in teacher){
	// 		if(teacher[key] == null){
	// 			delete teacher[key]
	// 		}
	// 	}
		
	// 	return $http.put(`user/${id}`, teacher, {
	// 		headers : {
	// 			// 'Content-Type' : 'undefined',
	// 			'x-auth-token' : token
	// 		}
	// 	}).then((response) => {
	// 		commit('UPDATE_TEACHER', response.data)
	// 	})
	// },

	// deleteTeacher({commit}, {id, token}){
	// 	return $http.delete(`user/${id}`, {
	// 		headers : {
	// 			'x-auth-token' : token
	// 		} 
	// 	}).then(() => {
	// 		commit('REMOVE_TEACHER', id)	
	// 	})
	// },
}

const mutations = {
	SET_SCHOOL_STUDENTS : (state, schoolStudents) => {
		state.schoolStudents = schoolStudents
	},
	SET_SCHOOL_TEACHERS : (state, schoolTeachers) => {
		state.schoolTeachers = schoolTeachers
	},
	ADD_SCHOOL_STUDENT : (state, schoolUser) => {
		state.schoolStudents.push(schoolUser)
	},
	ADD_SCHOOL_TEACHER : (state, schoolUser) => {
		state.schoolTeachers.push(schoolUser)
	},
	SET_SCHOOL_DETAILS : (state, schoolDetails) => {
		state.schoolDetails.push(schoolDetails)
	},
	SET_SCHOOLS : (state, schools) => {
		state.schools = schools
	},
	SET_CURRENT_SCHOOL : (state, school) => {
		state.current_school = school
	},
	ADD_SCHOOL : (state, school) => {
		state.schools.unshift(school)
	},
	UPDATE_SCHOOL : (state, school) => {
		const idx = state.schools.findIndex(s => s._id == school._id)
		if(idx >= 0){
			Vue.set(state.schools, idx, Object.assign({}, school))
		}
		state.current_school = school
	},
	REMOVE_SCHOOL : (state, id) => {
		state.schools = state.schools.filter(s => s._id != id)
		if(state.current_school && state.current_school._id == id){
			state.current_school = null
		}
	},
	// UPDATE_CATEGORY : (state, category) => {
	// 	state.current_category = category
	// 	let cat_index = state.categories.findIndex(category_obj => category_obj._id == category._id)
	// 	Vue.set(state.categories, cat_index, Object.assign({}, category)) // For making it reactive
	// },
	// REMOVE_CATEGORY : (state, category_id) => {
	// 	state.categories = state.categories.filter(category => category._id != category_id)
	// 	if(state.current_category && (state.current_category._id == category_id)){
	// 		state.current_category = null
	// 	}
	// },
}

export default {
	state, getters, actions, mutations
}